export default "https://cdn-static-staging.gokick.com/assets/283628f6afcc58bd5c20cb35203f3b9e086ea5d6/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";